import React from 'react'
import { Accordion } from 'react-bootstrap';
import Icon from 'UI/FontAwesomeIcon'

const InformationAccordion = ({ information }) => {
  return (
    <Accordion className='information-accordion' flush>
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <Icon icon='info-circle' style={{ color: "blue" }} className="pr-3 text-2xl" />
          <span className='className="text-gray-500"'>More Information</span>
        </Accordion.Header>
        <Accordion.Body>
          <span className="text-gray-500">{information}</span>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}
export default InformationAccordion